import React from 'react';
import { Avatar } from '@mui/material';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import { CircleFlag } from 'react-circle-flags';

/** Round flag for a nation ISO code, or a globe / remote icon. */
export default function NationFlag({ tag, remote, size = 44 }) {
  const code = tag && String(tag).length === 2 ? String(tag).toLowerCase() : null;
  if (remote && !code) {
    return (
      <Avatar sx={{ width: size, height: size, bgcolor: '#ECFDF5', color: '#059669' }}>
        <HomeWorkRoundedIcon sx={{ fontSize: size * 0.5 }} />
      </Avatar>
    );
  }
  if (!code) {
    return (
      <Avatar sx={{ width: size, height: size, bgcolor: '#EEF2FF', color: 'primary.main' }}>
        <PublicRoundedIcon sx={{ fontSize: size * 0.55 }} />
      </Avatar>
    );
  }
  return (
    <Avatar sx={{ width: size, height: size, bgcolor: 'transparent', boxShadow: '0 4px 10px -4px rgba(15,23,42,0.35)' }}>
      <CircleFlag countryCode={code} height={size} width={size} alt="" />
    </Avatar>
  );
}
